import React, { useState, useContext, useEffect } from "react";

import AdminTopBar from "../Common/AdminTopBar";
import InterfaceMenu from "../Interfaces/InterfaceMenu";
import { api_handler } from "../../services/api";
import { GlobalDispatchContext,GlobalStateContext } from "../../state/GlobalContextProvider";


const Account = ({ interface_id }) => {
  const [interfaceEndpoints, setInterfaceEndpoints] = useState([]);
  const themeState = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);

  useEffect(() => {
    const getInterface = async () => {
      var data = {
        interface_id: interface_id,
      };
      const api_rsp = await api_handler("int-aisp-endpoint:list", data, "POST");
      setInterfaceEndpoints(api_rsp.data);
    };
    getInterface();
  }, [interface_id]);

  const toggle_endpoint = async (id, status) => {
    var data = {
      interface_id: interface_id,
      endpoint_id: id,
    };
    let api_url =
      status === "1" ? "int-aisp-endpoint:delete" : "int-aisp-endpoint:create";
    const api_rsp = await api_handler(api_url, data, "POST");

    if(api_rsp.code===200) { dispatch({ type: "TRIGGER_TOAST" }) }
   
    setInterfaceEndpoints(api_rsp.data);
  };

  return (
    <div>
      <AdminTopBar />
      <div className="section__master">
        <div className="grid grid-cols-12 gap-6">
          {/** <InterfaceMenu interface_id={interface_id} />*/}
          <div className="col-span-12 lg:col-span-12 xxl:col-span-12">
            <div className="Section__body">
              <div className="intro-y box">
                <div className="pt-0 ">
                  <h2 className="font-medium text-base mr-auto w-full">
                    Account Information Access
                  </h2>

                  <p>
                    An Account Information Service Provider (AISP) is permitted
                    to access account information and to perform certain
                    account-based activities on behalf of a user. An AISP needs
                    a user's explicit consent to do so. The way in which your
                    users provide Account Access consent is described in more
                    detail in the Integration Guide. You can manage which
                    Account Services you wish to expose to AISPs by selecting
                    from the list below.
                  </p>
                </div>
                <div className={"card  " + themeState.theme}>
                  <div className="card-header card-header-large bg-white d-flex align-items-center">
                    <h4 className="card-header__title flex m-0">
                      Account Information Endpoints
                    </h4>
                  </div>

                  <div className="list-group tab-content list-group-flush">
                    <div className="tab-pane active show fade" id="activity_all">
                      {interfaceEndpoints.map((ifaceEP, index) => (
                        <div key={ifaceEP.id}
                          className={
                            "list-group-item list-group-item-action d-flex align-items-center row" +
                            themeState.theme
                          }
                        >
                          <div className="avatar avatar-xs mr-3 col-1">
                            <span className="avatar-title rounded-circle method-dot bg-purple">
                              GET
                            </span>
                          </div>

                          <div className="flex list-flex col-12">
                            <div className="d-flex align-items-middle list-item-header">
                              <strong className="text-15pt mr-1">
                                {ifaceEP.endpoint}
                              </strong>
                            </div>
                            <div className="text-muted list-item-sub-header">
                              {ifaceEP.description}
                            </div>
                          </div>
                          
                          <div className="flex list-flex col-2">
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={ifaceEP.active === "1" ? true : false}
                              onChange={() =>
                                toggle_endpoint(ifaceEP.id, ifaceEP.active)
                              }
                              id="togBtn"
                            />
                            <div className="slider round"></div>
                          </label>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="tab-pane" id="activity_quotes"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Account;
